var map = {
	"./application-dashboard.svg": "3e28",
	"./database-dashboard.svg": "6bb9",
	"./domain-dashboard.svg": "2386",
	"./middleware-dashboard.svg": "7d37",
	"./network_device-dashboard.svg": "ef17",
	"./os-dashboard.svg": "816e",
	"./server-dashboard.svg": "57a4",
	"./site-dashboard.svg": "4c32",
	"./ssl_certificate-dashboard.svg": "f4b7",
	"./storage-dashboard.svg": "b3ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dde8";